import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  RegistroHorasHistorial,
  TipoCambioHistorial,
} from '../../../../../models/personal/registro-horas.model';
import { RegistroHorasService } from '../../../../../services/employees/registro-horas.service';

export interface HistorialRegistroModalData {
  registroHorasId: number;
}

/**
 * Diálogo de solo lectura que muestra el histórico de auditoría (ediciones, rechazos,
 * validaciones) de un registro de horas.
 */
@Component({
  selector: 'app-historial-registro-modal',
  templateUrl: './historial-registro-modal.component.html',
  standalone: false,
})
export class HistorialRegistroModalComponent implements OnInit {
  historial: RegistroHorasHistorial[] = [];
  cargando = true;

  constructor(
    public dialogRef: MatDialogRef<HistorialRegistroModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HistorialRegistroModalData,
    private registroHorasService: RegistroHorasService
  ) {}

  ngOnInit(): void {
    this.registroHorasService.obtenerHistorial(this.data.registroHorasId).subscribe({
      next: (resultado) => {
        this.historial = resultado;
        this.cargando = false;
      },
      error: () => {
        this.cargando = false;
      },
    });
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  nombreTipoCambio(tipo: TipoCambioHistorial): string {
    switch (tipo) {
      case TipoCambioHistorial.Modificacion:
        return 'Edición';
      case TipoCambioHistorial.Rechazo:
        return 'Rechazo';
      case TipoCambioHistorial.Validacion:
        return 'Validación';
      case TipoCambioHistorial.Cancelacion:
        return 'Cancelación';
      default:
        return 'Desconocido';
    }
  }
}
